import { Component } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { EntityImportedData } from '../dataImported.model';

@Component({
  selector: 'app-filter-counterparties-dialog',
  templateUrl: './filter-counterparties-dialog.component.html',
  styleUrls: ['./filter-counterparties-dialog.component.css']
})
export class FilterCounterpartiesDialogComponent {
  counterpartiesToFilter: EntityImportedData[] = [];
  getEntityDisplayName: (entity: EntityImportedData) => string;

  constructor(public dialogRef: MdDialogRef<FilterCounterpartiesDialogComponent>) {}

  /**
   * Get display name for an entity
   */
  getDisplayName(entity: EntityImportedData): string {
    if (this.getEntityDisplayName) {
      return this.getEntityDisplayName(entity);
    }
    if (entity.organisation && entity.organisation.name) {
      return entity.organisation.name;
    }
    if (entity.person) {
      if (entity.person.firstNames && entity.person.lastNames) {
        return entity.person.firstNames + ' ' + entity.person.lastNames;
      }
      if (entity.person.callingName) {
        return entity.person.callingName;
      }
    }
    return '';
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}




// WEBPACK FOOTER //
// ./src/app/admin/import/review/filter-counterparties-dialog.component.ts